import { useModuleGate, useModuleGateForWorkspace } from '../lib/moduleGate';

/**
 * True when the announced-vs-committed readout is on: priorities carry a
 * derived commitment state, the Plan of Record shows the portfolio rollup, and
 * the displacement question is asked at admission. Canonical gate (§2.7):
 * `commitment_states` workspace module + flag.
 *
 * PRD: docs/9-exploration/DISPLACEMENT-AND-COMMITMENT-STATES-PRD.md.
 */
export function useCommitmentStatesEnabled(): boolean {
  return useModuleGate('commitment_states');
}

/**
 * The same gate resolved against the workspace a rendered record belongs to,
 * for record-scoped surfaces (a Plan of Record opened by URL can belong to a
 * workspace other than the session's — the 2026-08-21 defect).
 */
export function useCommitmentStatesEnabledForWorkspace(
  workspaceId: string | null | undefined
): boolean {
  return useModuleGateForWorkspace(workspaceId, 'commitment_states');
}
